import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { eliminarCliente } from '../../../actions/clientes';

const EliminarClienteModal = ({ show, onHide, idCliente }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idCliente) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(eliminarCliente(idCliente));
        setSaving(false);

        if (ok) {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Eliminar cliente</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas eliminar este cliente? Esta acción no es reversible.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Eliminar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarClienteModal;
